export const SET_SELECTED_BLOCK = 'SET_SELECTED_BLOCK';
export const SET_BROWSER_ITEMS_ORDER = 'SET_BROWSER_ITEMS_ORDER';
export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';
export const SET_SELECTED_ZONE_OF_CONSUME = 'SET_SELECTED_ZONE_OF_CONSUME';
export const SET_TABLE_GUID = 'SET_TABLE_GUID';
export const SET_PRICES = 'SET_PRICES';
export const SET_USER_DEFINED_DATA = 'SET_USER_DEFINED_DATA';
export const SET_TICKET_DETAIL_SUCCESS = 'SET_TICKET_DETAIL_SUCCESS';
export const SET_SUBDOMAIN_SUCCESS = 'SET_SUBDOMAIN_SUCCESS';
export const SET_SALE_LOCATION_GUID_SUCCESS = 'SET_SALE_LOCATION_GUID_SUCCESS';
export const SET_STATUS_SUCCESS = 'SET_STATUS_SUCCESS';
export const SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL';
export const SET_CURRENCY_POSITION = 'SET_CURRENCY_POSITION';
export const SET_SHOW_FEATURES = 'SET_SHOW_FEATURES';
export const SET_SHOW_ICON_FEATURES = 'SET_SHOW_ICON_FEATURES';
export const SET_SHOW_PRODUCT_TAGS = 'SET_SHOW_PRODUCT_TAGS';
export const SET_SHOW_ICON_PRODUCT_TAGS = 'SET_SHOW_ICON_PRODUCT_TAGS';
export const SET_SCROLL_BROWSER_SELECTION = 'SET_SCROLL_BROWSER_SELECTION';
export const SET_CLAUSE_GUID_WITH_SECTIONS_GUID = 'SET_CLAUSE_GUID_WITH_SECTIONS_GUID';
export const ADD_SHOP_LIST = 'ADD_SHOP_LIST';
export const SUBTRACT_SHOP_LIST = 'SUBTRACT_SHOP_LIST';
export const RESET_SHOP_LIST = 'RESET_SHOP_LIST';
